require('js-cookie');
require('./init');

// Sass
require('./../sass/index.sass');